import React, { useCallback, useEffect, useState } from 'react';
import './index.less';
import './slideVerifyNew.less';

import { aliyunSlideProps } from '@/components/Login/typings';
// import '@/utils/gt4';

interface verifyProps {
  slideChange: (values: aliyunSlideProps) => void;
  backChange: () => void;
  registerStatus: number;
}

function Verify(props: verifyProps) {
  const [verifyState, setVerifyState] = useState<{ state: boolean }>({
    state: false
  });
  const captchaId1 = '307f2719e8ab5305efb5e8d5eb0c152b';
  const captchaId2 = '34cc09b11d29184fc81084882772a70f';
  const captchaId3 = 'df1315f458ef86f8c71946cc52e0054f';
  const init = useCallback(() => {
    let captchaId = captchaId3;
    if (props.registerStatus === 1) {
      captchaId = captchaId1;
    } else if (props.registerStatus === 2) {
      captchaId = captchaId2;
    }
    (window as any).initGeetest4(
      {
        captchaId,
        product: 'float'
      },
      (captcha: any) => {
        captcha.onSuccess(() => {
          const result2: any = captcha.getValidate();
          console.log(result2, 111);
          const param: any = {
            captcha_output: result2.captcha_output,
            gen_time: result2.gen_time,
            lot_number: result2.lot_number,
            pass_token: result2.pass_token
          };
          verifyState.state = true;
          setVerifyState({ ...verifyState });
          props.slideChange(param);
          captcha.reset(); // 调用该接口进行重置
        });
        captcha.appendTo(`#captcha-box${props.registerStatus}`);
      }
    );
    // };
  }, [props]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    init();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className={`jiyan_login_layout jiyan_login_layout${props.registerStatus}`}>
      {/* <div id="captcha-box1" className={classnames(verifyState.state ? 'jiyan_success_verify' : '')}></div> */}
      <div id={'captcha-box' + props.registerStatus}></div>
    </div>
  );
}

export default Verify;
